export default __webpack_public_path__ + "static/media/insta.cebd72e3.png";